import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Modal, ModalCTA } from 'containers/misc'
import { Title } from 'components/layout'
import { Button } from 'components/misc'
import { CircleLoader } from 'components/loaders'
import modalIds from 'constants/modals'

export default class TranslationsManagementModal extends Component {
  static propTypes = {
    onUpdateTranslations: PropTypes.func.isRequired,
    onCloseDialog: PropTypes.func,
    isUpdateInProgress: PropTypes.bool.isRequired
  }

  updateTranslations = () => {
    const { onUpdateTranslations } = this.props

    onUpdateTranslations()
  }

  closeDialog = () => {
    const { onCloseDialog } = this.props

    this.setState({
      updateTranslations: false
    })
    onCloseDialog()
  }

  render() {
    const { isUpdateInProgress } = this.props

    return (
      <Modal id={modalIds.TRANSLATIONS_MANAGER_MODAL} customActions>
        <Title
          h2
          className="text--center"
          intlKey="translationsManagement.modal.title"
        >
          Do you know what you are doing?
        </Title>
        <div className="text--center">
          Make sure to update strings on CTEST first and test them there
        </div>
        <div className="row base-margin--top">
          <div className="col-xs-12">
            <div className="col-xs-6">
              <Button
                type="button"
                onClick={() => this.closeDialog()}
                intlKey="button.cancel"
                secondary
              >
                Cancel
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                type="button"
                intlKey="button.continue"
                onClick={() => this.updateTranslations()}
              >
                Continue
              </Button>
            </div>
          </div>
        </div>
        {isUpdateInProgress && (
          <ModalCTA>
            <div className="col-xs-12">
              <Title
                h2
                className="text--center"
                intlKey="translationsManagement.modal.updateTitle"
              >
                Update in progress
              </Title>
              <CircleLoader size={60} />
            </div>
          </ModalCTA>
        )}
      </Modal>
    )
  }
}
